import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";
import { useState } from "react";
import { isEmptyObject } from "@/src/components/common/common";
// import ConfirmDialog from "@/src/components/confirm-dialog/ConfirmDialog";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import { useToast } from "@/src/lib/hooks/useToast";
import DeleteTestConfirmation from "./deleteTestConfirmation";
import DeleteTestConfirmationHeader from "./deleteTestConfirmationHeader";
import { useDispatch } from "react-redux";
import { fetchSessionDetails } from "@/src/lib/util/fetchSessionDetails";
import { useRouter } from "next/router";
import useCheckoutHook from "@/src/lib/module-helper/my-account/hook/useCheckkoutHook";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import useAuth from "@/src/lib/hooks/useAuth";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import CustomIconButton from "@/src/lib/ui/iconButton";
import CustomTooltip from "@/src/lib/ui/customTooltip";

const PatientWiseTest = ({
    cartItems,
    isDeletePatient = true,
    refetchCheckoutData,
    productandPatientName = "text-lg",
    innerContainer = "p-4",
    paddingContainer = "px-4 py-3",
    priceText = "text-lg",
    iconwidth = 20,
    ruppeeIcon = 18,
    voucherId,
}) => {
    const router = useRouter();
    const { showToast } = useToast();
    const dispatch = useDispatch();
    const { isLoggedIn } = useAuth();
    const { data: isCartCountData, refetch: isCartCountRefetch } =
        useCustomQuery("cart_count", cartApiService.getCartCount, {
            enabled: isLoggedIn && isLoggedIn,
            staleTime: 2000, // Adjust to avoid refetching too often
        });

    const [open, setOpen] = useState({});

    const onDeleteTestHandler = (cart, items) => {
        setOpen({ ...cart, items });
    };

    const isOpened = !isEmptyObject(open);

    const { mutate, isLoading: isPending } = useHODMutation(
        (data) => cartApiService.removeCartItem(data),
        {
            onSuccess: async (data) => {
                showToast(data, "success");
                refetchCheckoutData();
                await fetchSessionDetails(dispatch);
                isCartCountRefetch();
                onClose();
            },
            onError: (error) => {
                showToast(error, "error");
            },
        }
    );

    const onConfirmTestDeleteHandler = (items) => {
        const payload = {
            data: {
                checkoutLineId: items?.items?.checkoutLineId,
                visitType: items?.visitType,
                voucherId: voucherId,
            },
        };
        mutate(payload);
    };

    const onClose = () => {
        setOpen({});
    };

    const onTestChangeHandler = (productSlug) => {
        router.push(`/test/${productSlug}`);
    };

    return (
        <>
            {" "}
            <div className="shadow-md rounded-lg bg-white overflow-hidden mb-5">
                <div
                    className={`bg-gray-200 border-b border-solid border-white flex item-center justify-items-center ${paddingContainer}`}
                >
                    <p
                        className={`text-black text-sm font-bold mr-2 ${productandPatientName}`}
                    >
                        {cartItems?.patientName}
                    </p>
                    <p className="text-xs text-gray-500 font-medium">
                        {cartItems?.patientAge} / {cartItems?.patientGender}
                    </p>
                </div>

                <div className="p-3 flex-wrap flex">
                    {!!cartItems?.items?.length &&
                        cartItems?.items?.map((item, index) => {
                            return (
                                <div
                                    className="px-2 py-1 border border-solid border-gray-300 rounded-md mr-2 mb-2 flex justify-centre items-center"
                                    key={index}
                                >
                                    <CustomTooltip
                                        title={item?.productDetail?.productName}
                                    >
                                        <p
                                            className="text-black text-sm font-bold cursor-pointer decoration-1 hover:underline max-w-[180px] truncate"
                                            onClick={() =>
                                                onTestChangeHandler(
                                                    item?.productDetail
                                                        ?.productSlug
                                                )
                                            }
                                        >
                                            {item?.productDetail?.productName}
                                        </p>
                                    </CustomTooltip>
                                    <div className="flex flex-row items-center pl-1">
                                        <Iconify
                                            icon={IconCode.rupeeLight}
                                            width={14}
                                            className="text-primary"
                                        />
                                        <p className="text-primary text-xs font-bold line-through">
                                            {item.liveMrp}
                                        </p>
                                    </div>

                                    <div className="flex flex-row items-center px-1">
                                        <Iconify
                                            icon={IconCode.rupeeLight}
                                            width={14}
                                            className="text-black"
                                        />
                                        <p className="text-black text-xs font-bold">
                                            {item.liveRate}
                                        </p>
                                    </div>

                                    {isDeletePatient && (
                                        <CustomIconButton className="p-1">
                                            <Iconify
                                                className="text-primary cursor-pointer"
                                                onClick={() =>
                                                    onDeleteTestHandler(
                                                        cartItems,
                                                        item
                                                    )
                                                }
                                                icon={IconCode.delete}
                                                width={14}
                                            />
                                        </CustomIconButton>
                                    )}
                                </div>
                            );
                        })}
                    {/* <p className="text-black px-4">
                            asdf
                        </p> */}
                    {/* </Stack> */}
                </div>
            </div>
            {isOpened && (
                <ConfirmDialog
                    maxWidth="sm"
                    open={isOpened}
                    className="m-4 sm:m-6"
                    //  onClose={onClose}
                    isCancel={true}
                    title={
                        <DeleteTestConfirmationHeader
                            open={open}
                            onClose={onClose}
                        />
                    }
                    content={
                        <DeleteTestConfirmation
                            onConfirmTestDeleteHandler={
                                onConfirmTestDeleteHandler
                            }
                            onClose={onClose}
                            open={open}
                            isPending={isPending}
                        />
                    }
                />
            )}
        </>
    );
};

export default PatientWiseTest;
